import React from "react";
import classnames from "classnames";
import { Element } from "../base";
import MenuList from "./list";

interface IProps {
    className?: string;
    children: React.ReactNode;
}

function Menu(props: IProps) {
    const { className, children, ...rest } = props;
    return (
        <Element
            className={classnames(
                "menu",
                "max-w-[300px] min-w-[220px] absolute text-left rounded-[8px]",
                className
            )}
            {...rest}
        >
            {children}
        </Element>
    );
}

Menu.List = MenuList;

export default Menu;
